export const hostname = process.env.NEXT_PUBLIC_HOSTNAME as string
export const baseURLServer = process.env.NODE_RUNTIME_BASEURL_SERVER || process.env.NEXT_PUBLIC_BASEURL_SERVER
export const baseURLServerReferer = process.env.NEXT_PUBLIC_BASEURL_SERVER_REFERER as string
export const baseURLClient = process.env.NEXT_PUBLIC_BASEURL_CLIENT as string
export const tradeWebsocketURL = process.env.NEXT_PUBLIC_TRADE_WEBSOCKET_URL as string
export const contractWebsocketURL = process.env.NEXT_PUBLIC_CONTRACT_WEBSOCKET_URL as string
export const chatWebsocketURL = process.env.NEXT_PUBLIC_CHAT_WS as string
export const googleClientId = process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID as string
export const googleChannel = process.env.NEXT_PUBLIC_GOOGLE_CHANNEL as string
export const appleClientId = process.env.NEXT_PUBLIC_APPLE_CLIENT_ID as string
export const appleChannel = process.env.NEXT_PUBLIC_APPLE_CHANNEL as string
export const tgBotToken = process.env.TG_BOT_TOKEN as string
export const tgBotId = process.env.NEXT_PUBLIC_TG_BOT_ID as string
export const tgChannel = process.env.NEXT_PUBLIC_TG_CHANNEL as string
export const tgBotName = process.env.NEXT_PUBLIC_TG_BOT_NAME as string
export const gaMeasurementId = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID as string
export const gtmId = process.env.NEXT_PUBLIC_GTM_ID as string
export const versionCode = '3.2.0'
// copy form vue localeList
export const localeMap = {
  zh_CN: {
    name: '简体中文（马来西亚）',
    value: 'zh',
    smallValue: 'zh_CN',
    klineLocal: 'CN',
    geeTestLocal: 'zho',
    tgLocal: 'en',
    alchemypayLocal: 'zh-HK',
  },
  zh_HK: {
    name: '繁體中文',
    value: 'hk',
    smallValue: 'zh_HK',
    klineLocal: 'CN',
    geeTestLocal: 'zho',
    tgLocal: 'en',
    alchemypayLocal: 'zh-HK',
  },
  en_US: {
    name: 'English',
    value: 'en',
    smallValue: 'en_US',
    klineLocal: 'EN',
    geeTestLocal: 'eng',
    tgLocal: 'en',
    alchemypayLocal: 'en-US',
  },
  // ko_KR: {
  //   name: '한국어',
  //   value: 'ko',
  //   smallValue: 'ko_KR',
  //   klineLocal: 'KO',
  //   geeTestLocal: 'eng',
  //   tgLocal: 'ko',
  //   alchemypayLocal: 'en-US',
  // },
  th_TH: {
    name: 'อักษรไทย',
    value: 'th',
    smallValue: 'th_TH',
    klineLocal: 'TH',
    geeTestLocal: 'eng',
    tgLocal: 'en',
    alchemypayLocal: 'en-US',
  },
  fil_PH: {
    name: 'Filipino',
    value: 'fil',
    smallValue: 'fil_PH',
    klineLocal: 'FIL',
    geeTestLocal: 'eng',
    tgLocal: 'en',
    alchemypayLocal: 'en-US',
  },
  es_ES: {
    name: 'Español',
    value: 'es',
    smallValue: 'es_ES',
    klineLocal: 'ES',
    geeTestLocal: 'eng',
    tgLocal: 'es',
    alchemypayLocal: 'es',
  },
  ja_JP: {
    name: '日本語',
    value: 'ja',
    smallValue: 'ja_JP',
    klineLocal: 'JA',
    geeTestLocal: 'eng',
    tgLocal: 'en',
    alchemypayLocal: 'en-US',
  },
  pt_PT: {
    name: 'Português(Portugal)',
    value: 'pt',
    smallValue: 'pt_PT',
    klineLocal: 'PT',
    geeTestLocal: 'eng',
    tgLocal: 'pt',
    alchemypayLocal: 'en-US',
  },
  vi_VN: {
    name: 'Tiếng Việt',
    value: 'vi',
    smallValue: 'vi_VN',
    klineLocal: 'VI',
    geeTestLocal: 'eng',
    tgLocal: 'en',
    alchemypayLocal: 'en-US',
  },
  fr_FR: {
    name: 'Français',
    value: 'fr',
    smallValue: 'fr_FR',
    klineLocal: 'FR',
    geeTestLocal: 'eng',
    tgLocal: 'fr',
    alchemypayLocal: 'en-US',
  },
  // tr_TR: {
  //   name: 'Türkçe',
  //   value: 'tr',
  //   smallValue: 'tr_TR',
  //   klineLocal: 'TR',
  //   geeTestLocal: 'eng',
  //   tgLocal: 'tr',
  //   alchemypayLocal: 'en-US',
  // },
  // de_DE: {
  //   name: 'Deutsch',
  //   value: 'de',
  //   smallValue: 'de_DE',
  //   klineLocal: 'EN',
  //   geeTestLocal: 'eng',
  //   tgLocal: 'de',
  //   alchemypayLocal: 'en-US',
  // },
  ru_RU: {
    name: 'русский',
    value: 'ru',
    smallValue: 'ru_RU',
    klineLocal: 'EN',
    geeTestLocal: 'eng',
    tgLocal: 'ru',
    alchemypayLocal: 'en-US',
  },
  it_IT: {
    name: 'italiano',
    value: 'it',
    smallValue: 'it_IT',
    klineLocal: 'EN',
    geeTestLocal: 'eng',
    tgLocal: 'it',
    alchemypayLocal: 'en-US',
  },
}

export const Environment = {
  /* 生产环境 */
  PRODUCTION: 1,
  /* 测试环境 */
  TEST: 2,
  /* 开发环境 */
  DEV: 3,
} as const
